import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useProjects, useProject } from '../hooks/useProjects';

interface ProjectContextType {
  projects: any[];
  currentProjectId: string | null;
  currentProject: any | null;
  setCurrentProjectId: (id: string | null) => void;
  isLoading: boolean;
  error: Error | null;
}

const ProjectContext = createContext<ProjectContextType | null>(null);

export function ProjectProvider({ children }: { children: ReactNode }) {
  const [currentProjectId, setCurrentProjectId] = useState<string | null>(null);
  const { data: projects = [], isLoading: projectsLoading, error: projectsError } = useProjects();
  const { data: currentProject, isLoading: projectLoading } = useProject(currentProjectId || '');

  // Auto-select first project
  useEffect(() => {
    if (projects.length > 0 && !currentProjectId) {
      setCurrentProjectId(projects[0].id);
    }
  }, [projects, currentProjectId]);

  return (
    <ProjectContext.Provider
      value={{
        projects,
        currentProjectId,
        currentProject: currentProject || null,
        setCurrentProjectId,
        isLoading: projectsLoading || projectLoading,
        error: projectsError as Error | null,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
}

export function useProjectContext() {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProjectContext must be used within ProjectProvider');
  }
  return context;
}
